import styled from 'styled-components';

import { colorsPalettes } from '@similarweb/styles';

import { Button } from '../Button';

export const StyledCloseButton = styled(Button)`
  padding: 4px;
  position: relative;
  width: 24px;
  height: 24px;
  margin-right: -4px;

  &::before {
    content: '';
    display: block;
    width: 12px;
    height: 2px;
    border-radius: 2px;
    background-color: ${colorsPalettes.carbon[300]};
    position: absolute;
    top: calc(50% - 1px);
    left: calc(50% - 6px);
  }
`;
